import { z } from "zod";

export const getCapacityUtilizationQuerySchema = z.object({
	year: z.coerce.number().int().min(2000).max(2100),
	id: z.string(),
	type: z.enum(["member", "partnership"]),
});

export type GetCapacityUtilizationQuerySchema = z.infer<typeof getCapacityUtilizationQuerySchema>;
